import { IconButton } from "@material-ui/core";
import { noop } from "lodash";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

export const PushPin = ({ pinned, onPin }) => {
  const GREYED_OUT = "#99999960";
  const enabled = {
    pin: "#D8D8D8",
    thumb: "#AF1B1B",
    staff: "#DD342E",
  };
  const disabled = Object.keys(enabled).reduce((acc, nxt) => {
    acc[nxt] = GREYED_OUT;
    return acc;
  }, {});

  const [colors, setColors] = useState(disabled);

  useEffect(() => {
    setColors(pinned ? enabled : disabled);
  }, [pinned]);

  return (
    <IconButton
      onClick={onPin}
      style={{
        display: "flex",
        justifyContent: "center",
        transform: "rotate(315deg)",
      }}
    >
      <svg
        height="20px"
        width="20px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 513.103 513.103"
      >
        <path
          fill={colors.pin}
          d="M0,513.103L0,513.103L0,513.103c4.414-20.303,14.124-38.841,29.131-53.848l177.434-177.434
    l24.717,24.717L53.848,483.972C38.841,498.979,20.303,508.69,0,513.103"
        />
        <path
          fill={colors.thumb}
          d="M309.848,385.986L127.117,203.255c-7.062-7.062-4.414-18.538,5.297-22.069l22.069-7.062
    c20.303-7.062,42.372-1.766,57.379,13.241l112.993,113.876c15.007,15.007,20.303,37.076,13.241,57.379l-7.062,22.069
    C328.386,389.517,316.028,393.048,309.848,385.986"
        />
        <polygon
          fill={colors.staff}
          points="324.855,301.241 211.862,188.248 361.931,63.779 449.324,151.172 "
        />
        <path
          fill={colors.thumb}
          d="M473.159,174.124L338.979,39.945c-4.414-4.414-4.414-11.476,0-15.89L358.4,4.634
    c6.179-6.179,15.007-6.179,21.186,0l128.883,128.883c6.179,6.179,6.179,15.007,0,21.186l-18.538,18.538
    C483.752,178.538,476.69,178.538,473.159,174.124"
        />
      </svg>
    </IconButton>
  );
};

PushPin.propTypes = {
  pinned: PropTypes.bool,
  onPin: PropTypes.func,
};
PushPin.defaultProps = {
  pinned: false,
  onPin: noop,
};
